import React, { useContext, useState } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { Form, FormGroup, Button, Input } from "reactstrap";
import MyLoader from "./util/loader";
import MyError from "./util/error";
import Api from "./api/api";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";
import { AuthContext } from "../context/AuthContext";

const ForgotPassword = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const { isLoggedIn } = useContext(AuthContext);

  if (isLoggedIn) {
    console.log("already logged in");
    history.push("/");
    return null;
  }

  const submitPassword = () => {
    if (email === "") {
      return;
    }
    setLoader(true);
    Api.resetAdminPassword(
      email,
      (response) => {
        console.log(JSON.stringify(response));
        setLoader(false);
        if (response.status === "success") {
          showToast("success", "Email sent with new password!");
        } else {
          setShowError(true);
          setError("Could not submit!");
        }
      },
      (error) => {
        setLoader(false);
        setShowError(true);
        setError("Could not submit!");
      }
    );
  };

  return (
    <div className="app">
      <div className="text-center text-white">
        <h4>Forgot Password</h4>
      </div>
      <Form className="form">
        <FormGroup>
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </FormGroup>

        <MyError showError={showError} error={error} />

        <Button
          style={{ marginTop: 20, fontSize: 16 }}
          className="btn-block btn-dark"
          onClick={submitPassword}
        >
          Submit
        </Button>
      </Form>
      <MyLoader loader={loader} marginTop={-10} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default ForgotPassword;
